import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import * as React from 'react'

interface IExpirationIconProps {
  className?: string
  date?: number
  style?: React.CSSProperties
}

export default class ExpirationIcon extends React.PureComponent<
  IExpirationIconProps
> {
  public render() {
    if (this.props.date === undefined) {
      return null
    }

    if (this.props.date < moment().unix()) {
      return (
        <span
          className={this.props.className}
          style={this.props.style}
          title='Expired'
        >
          <FontAwesomeIcon
            className='text-danger'
            fixedWidth
            icon={['fas', 'exclamation-triangle']}
          />
        </span>
      )
    } else if (
      this.props.date <
      moment()
        .add(30, 'days')
        .unix()
    ) {
      return (
        <span
          className={this.props.className}
          style={this.props.style}
          title='Expires Soon'
        >
          <FontAwesomeIcon
            className='text-warning'
            fixedWidth
            icon={['far', 'exclamation-triangle']}
          />
        </span>
      )
    } else {
      return null
    }
  }
}
